import { getAppBaseUrl } from "@/lib/app-base-url";
import { buildListingUrl } from "@/lib/slugify";

export function getJobShareUrl(
  slug: string,
  title: string,
  orgName: string
): string {
  return `${getAppBaseUrl()}${buildListingUrl(slug, title, orgName)}`;
}

export function getJobShareText(title: string, orgName: string): string {
  return `Check out this job: ${title} at ${orgName} on VacWork`;
}

export function getPlatformUrl(
  platform: string,
  url: string,
  text: string
): string {
  switch (platform) {
    case "whatsapp":
      return `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`;
    case "facebook":
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    case "twitter":
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
    case "linkedin":
      return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
    default:
      return url;
  }
}
